module.exports = __webpack_public_path__ + "static/media/appcoins.fe6e0581.png";